"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = require("react-loadable");

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _common = require("../modules/common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement("div", null);
};

// pgr employee specific screens


var Login = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/User/Login");
  },
  loading: Loading
});
var OTP = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/User/OTP");
  },
  loading: Loading
});

var RequestReAssign = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/RequestReAssign");
  },
  loading: Loading
});
// const AllComplaints = Loadable({
//   loader: () => import("../Screens/AllComplaints"),
//   loading: Loading
// });
var AllRequests = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/AllApplications");
  },
  loading: Loading
});

var ServicesTest = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ServicesTest");
  },
  loading: Loading
});

// const MasterData = Loadable({
//   loader: () => import("../Screens/MasterData"),
//   loading: Loading
// });
var OsbmFeeMasterData = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MasterData/OsbmFeeMasterData");
  },
  loading: Loading
});

var RoomFeeMasterData = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MasterData/RoomFeeMasterData");
  },
  loading: Loading
});

var OsujmFeeMasterData = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MasterData/OsujmFeeMasterData");
  },
  loading: Loading
});
var PaccMasterData = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MasterData/PaccMasterData");
  },
  loading: Loading
});
var ApproverMasterData = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MasterData/ApproverMasterData");
  },
  loading: Loading
});
var ApplicationResolved = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationResolved");
  },
  loading: Loading
});
// const ComplaintCreated = Loadable({
//   loader: () => import("../Screens/ComplaintCreated"),
//   loading: Loading
// });
var ApplicationSummary = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationDetails");
  },
  loading: Loading
});

var ParkAndCommunityCenterAppDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ParkAndCommunityCenterAppDetails");
  },
  loading: Loading
});
// const LocationSummary = Loadable({
//   loader: () => import("../Screens/LocationSummaryComponent"),
//   loading: Loading
// });

var CGApplicationDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/CGApplicationDetails");
  },
  loading: Loading
});

var AllMCCApplication = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/AllMCCApplication");
  },
  loading: Loading
});

var OSWMCCApplicationDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/OSWMCCApplicationDetails");
  },
  loading: Loading
});

var ApplicationBWTSummary = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/BwtApplicationDetails");
  },
  loading: Loading
});
//Successpagepcc
var CreateSuccessForPCC = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/CreateSuccessForPCC");
  },
  loading: Loading
});

var CreateSuccessForRoomBooking = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/CreateSuccessForRoomBooking");
  },
  loading: Loading
});
//NewLocationApplicationDetails
var NewLocationApplicationDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/NewLocationApplicationDetails");
  },
  loading: Loading
});
//payment-success-page   PaymentSuccessForEmployee
var PaymentSuccessForEmployee = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/PaymentSuccessForEmployee");
  },
  loading: Loading
});
//PaymentSuccessForEmployeeRoomBooking
var PaymentSuccessForEmployeeRoomBooking = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/PaymentSuccessForEmployeeRoom");
  },
  loading: Loading
});

//Cancel an application from emp
var ApplyCancelEmpApplication = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplyCancelEmpApplication");
  },
  loading: Loading
});
//ApplyRefundEmpApplication
var ApplyRefundEmpApplication = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplyRefundEmpApplication");
  },
  loading: Loading
});
//applyResourceCommercialGround
var applyResourceCommercialGround = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplyCommercialGround");
  },
  loading: Loading
});
var CheckAvailabilityPcc = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplyParkAndCommunity/components/CheckAvailability");
  },
  loading: Loading
});

var PaymentReceiptDteail = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ParkAndCommunityCenterAppDetails/components/PayPage");
  },
  loading: Loading
});
// RoomPayment
var RoomPayment = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/EmployeeRoomBooking/PayPage");
  },
  loading: Loading
});
//RoomBooking
var RoomBooking = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/EmployeeRoomBooking/CheckApplicationPage");
  },
  loading: Loading
});
var BeforeApplyScreen = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/EmployeeRoomBooking/BeforeApplyScreen");
  },
  loading: Loading
});
var RoomSteeper = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/EmployeeRoomBooking/formForRoomApplication");
  },
  loading: Loading
});
var ApplicationDetailForRoom = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/EmployeeRoomBooking/ApplicationDetailsPage");
  },
  loading: Loading
});
// const RoomSteeper = Loadable({
//   loader: () => import("../Screens/EmployeeRoomBooking/formForRoomApplication"),
//   loading: Loading
// })
var ServiceHome = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationDetails");
  },
  loading: Loading
});

var AssignComplaint = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/AssignComplaint");
  },
  loading: Loading
});
var EmployeeDirectory = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/EmployeeDirectory");
  },
  loading: Loading
});
// const ClosedComplaints = Loadable({
//   loader: () => import("../Screens/ClosedComplaints"),
//   loading: Loading
// });
var RejectComplaint = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/RejectComplaint");
  },
  loading: Loading
});
var RejectBWTComplaint = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/RejectBWTBooking");
  },
  loading: Loading
});

var deliverBooking = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DeliveredBWTBooking");
  },
  loading: Loading
});
var notDeliverBooking = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/NotDeliveredBWTBooking");
  },
  loading: Loading
});

var AssignToDriver = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/AssignToDriver");
  },
  loading: Loading
});
var ApplicationRejected = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationRejected");
  },
  loading: Loading
});
var ApplicationSubmited = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationSubmited");
  },
  loading: Loading
});
var ApplicationBack = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationBack");
  },
  loading: Loading
});
var ApplicationForword = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationForword");
  },
  loading: Loading
});
var ApplicationFeedback = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplicationFeedback");
  },
  loading: Loading
});

var NewLocationApplication = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/NewLocationAppRejectPage");
  },
  loading: Loading
});

// const ComplaintAssigned = Loadable({
//   loader: () => import("../Screens/ComplaintAssigned"),
//   loading: Loading
// });
var ResolveSuccess = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ResolveSuccess");
  },
  loading: Loading
});

var PublishSuccess = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/PublishSuccess");
  },
  loading: Loading
});
var NewLocationApproved = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/NewLocationApproved");
  },
  loading: Loading
});
var CreateSuccess = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/CreateWBTApplicationSuccess");
  },
  loading: Loading
});
var AssignToDriverSuccess = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/AssignToDriverSuccess");
  },
  loading: Loading
});

var RejectBWTApplicationSuccess = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/RejectBWTApplicationSuccess");
  },
  loading: Loading
});

var DeliveredApplicationSuccess = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DeliveredBWTApplicationSuccess");
  },
  loading: Loading
});
var ReassignSuccess = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ReassignSuccess");
  },
  loading: Loading
});
// const CreateComplaint = Loadable({
//   loader: () => import("../Screens/CreateComplaint"),
//   loading: Loading
// });
var SearchScreen = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/SearchScreen");
  },
  loading: Loading
});

var ApplyWaterTanker = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplyWaterTanker");
  },
  loading: Loading
});

var CgFeeMasterData = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MasterData/CgFeeMasterData");
  },
  loading: Loading
});

var ApplyPArkAndCommunity = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplyParkAndCommunity");
  },
  loading: Loading
});

var testing = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/testing");
  },
  loading: Loading
});

var ReservedDatesList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ReservedBookingDates");
  },
  loading: Loading
});

var ReserveDates = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ApplyParkAndCommunity/components/CheckAvailability/ReserveDates");
  },
  loading: Loading
});
// const MyTry = Loadable({
//   loader: () => import("../Screens/MyTry/payment-methods"),
//   loading: Loading
// })

// import CreateEmployee from "modules/employee/pgr/CreateEmployee";
var redirectionUrl = "/user/login";
var routes = [{
  path: "user/login",
  component: Login,
  needsAuthentication: false,
  redirectionUrl: "/"
}, {
  path: "user/otp",
  component: OTP,
  needsAuthentication: false,
  redirectionUrl: "/"
},
// {
//   path: "all-complaints",
//   component: AllComplaints,
//   needsAuthentication: true,
//   options: {
//     hideFooter: true,
//     title: "ES_OPEN_COMPLAINTS_HEADER",
//     hideTitle: false,
//     redirectionUrl,
//     hideFor: "ao",
//     customFor: "csr",
//     customTitle: "ES_ALL_COMPLAINTS_HEADER"
//   }
// },
{
  path: "egov-services/all-applications",
  component: AllRequests,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: " ",
    hideTitle: false,
    // redirectionUrl,
    // hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ALL_APPLICAION_HEADER"
  }
}, {
  path: "egov-services/PaymentReceiptDteail/:applicationId",
  component: PaymentReceiptDteail,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    // title: " ",
    hideTitle: false,
    customFor: "employee",
    customTitle: "Make Offline Payment"
    // customTitle: "BK_MYBK_PAYMENT_RCPT_DETAILS"
  }
}, {
  path: "egov-services/PaymentReceiptDteail/ForRoomBooking/:applicationId",
  component: RoomPayment,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    // title: " ",
    hideTitle: false,
    customFor: "employee",
    customTitle: "Make Offline Payment"
    // customTitle: "BK_MYBK_PAYMENT_RCPT_DETAILS"
  }
},
//RoomBooking
{
  path: "egov-services/ApplyForRoomBooking",
  component: RoomBooking,
  needsAuthentication: true,
  options: (0, _defineProperty3.default)({
    hideFooter: true,
    // title: " ",
    hideTitle: false,
    customFor: "employee",
    customTitle: "Make Offline Payment"
  }, "customTitle", "BK_MYBK_APPLY_FOR_ROOM_BOOKING")
}, //BeforeApplyScreen
{
  path: "egov-services/ApplyRoomBooking",
  component: BeforeApplyScreen,
  needsAuthentication: true,
  options: (0, _defineProperty3.default)({
    hideFooter: true,
    // title: " ",
    hideTitle: false,
    customFor: "employee",
    customTitle: "Make Offline Payment"
  }, "customTitle", "BK_MYBK_APPLY_FOR_ROOM_BOOKING")
},
//RoomSteeper
{
  path: "egov-services/Employee/ApplyRoomBooking",
  component: RoomSteeper,
  needsAuthentication: true,
  options: (0, _defineProperty3.default)({
    hideFooter: true,
    // title: " ",
    hideTitle: false,
    customFor: "employee",
    customTitle: "Make Offline Payment"
  }, "customTitle", "BK_MYBK_APPLY_FOR_ROOM_BOOKING")
},
//ApplicationDetailForRoom
{
  path: "egov-services/Employee/ApplicationDetailsForRoom/:applicationId",
  component: ApplicationDetailForRoom,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    // title: " ",
    hideTitle: false,
    customFor: "employee"
    // customTitle: "Make Offline Payment",
    // customTitle: "BK_MYBK_APPLY_FOR_ROOM_BOOKING"
  }
}, {
  path: "egov-services/ServicesTest",
  component: ServicesTest,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: " ",
    hideTitle: false,
    // redirectionUrl,
    // hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ALL_APPLICAION_HEADER"
  }
},

//successPageForPCC
{
  path: "egov-services/create-success-pcc",
  component: CreateSuccessForPCC,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    customFor: "employee",
    hideFooter: true,
    title: "",
    hideTitle: true,
    redirectionUrl: redirectionUrl
  }
},
//CreateSuccessForRoomBooking
{
  path: "egov-services/RoomBooking-Created-Successfully",
  component: CreateSuccessForRoomBooking,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    customFor: "employee",
    hideFooter: true,
    title: "",
    hideTitle: true,
    redirectionUrl: redirectionUrl
  }
},
//room success page
{
  path: "egov-services/Room-Payment-Success",
  component: PaymentSuccessForEmployeeRoomBooking,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    customFor: "employee",
    hideFooter: true,
    title: "",
    hideTitle: true,
    redirectionUrl: redirectionUrl
  }
},
// PaymentForEmployee
{
  path: "egov-services/success-payment",
  component: PaymentSuccessForEmployee,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    customFor: "employee",
    hideFooter: true,
    title: "",
    hideTitle: true,
    redirectionUrl: redirectionUrl
  }
},
//ApplyRefundEmpApplication
{
  path: "egov-services/apply-refund-success",
  component: ApplyRefundEmpApplication,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    customFor: "employee",
    hideFooter: true,
    title: "",
    hideTitle: true,
    redirectionUrl: redirectionUrl
  }
},

//ApplyCancelEmpApplication
{
  path: "egov-services/application-cancelled-success",
  component: ApplyCancelEmpApplication,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    customFor: "employee",
    hideFooter: true,
    title: "",
    hideTitle: true,
    redirectionUrl: redirectionUrl
  }
},
//ApplyCommercial
{
  path: "egov-services/applyResourceCommercialGround",
  component: applyResourceCommercialGround,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    customFor: "employee",
    hideFooter: true,
    title: "BK_CGB_APPLY",
    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customTitle: "BK_CGB_APPLY"
  }
},
//Apply PACC
{
  path: "egov-services/applyPark-community-center",
  component: ApplyPArkAndCommunity,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    //title: "BK_MYBK_APPLY_PACC_REQUEST_HEADER",
    title: "Application for Parks & Community Center/Banquet Halls",

    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    //customTitle: "BK_MYBK_APPLY_PACC_REQUEST_HEADER"
    customTitle: "Application for Parks & Community Center/Banquet Halls"
  }
},
//newMasterData
// {
//   path: "egov-services/MasterData",
//   component: MasterData,
//   needsAuthentication: true,
//   options: {
//     hideFooter: true,
//     title: " ",
//     hideTitle: false,
//     redirectionUrl,
//     hideFor: "ao",
//     customFor: "employee",
//     customTitle: "MYBK_ALL_APPLICAION_HEADER"
//   }
// },
{
  path: "egov-services/checkavailability_pcc",
  component: CheckAvailabilityPcc,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    // title: "BK_MYBK_APPLY_PACC_REQUEST_HEADER",
    // customTitle: "BK_MYBK_CHECK_AVAILABILITY_HEADER"

    title: "Application for Parks & Community Center/Banquet Halls",
    customTitle: "Application for Parks & Community Center/Banquet Halls"
  }
}, {
  path: "egov-services/admin/osbmFee",
  component: OsbmFeeMasterData,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_ADMIN_OSBM_FEE_HEADER",

    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ADMIN_OSBM_FEE_HEADER"
  }
}, {
  path: "egov-services/admin/roomFee",
  component: RoomFeeMasterData,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "Community Center Room Fee Master",

    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "Community Center Room Fee Master"
  }
}, {
  path: "egov-services/admin/approver",
  component: ApproverMasterData,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_ADMIN_APPROVER_FEE_HEADER",
    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ADMIN_APPROVER_FEE_HEADER"
  }
}, {
  path: "egov-services/admin/cgfee",
  component: CgFeeMasterData,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_ADMIN_CG_FEE_HEADER",
    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ADMIN_CG_FEE_HEADER"
  }
}, {
  path: "egov-services/admin/osujmfee",
  component: OsujmFeeMasterData,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_ADMIN_OSUJM_FEE_HEADER",
    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ADMIN_OSUJM_FEE_HEADER"
  }
}, {
  path: "egov-services/admin/pacc",
  component: PaccMasterData,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_ADMIN_PACC_FEE_HEADER",
    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ADMIN_PACC_FEE_HEADER"
  }
}, {
  path: "egov-services/applywatertanker",
  component: ApplyWaterTanker,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_APPLY_SPECIAL_REQUEST_HEADER",
    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_APPLY_SPECIAL_REQUEST_HEADER"
  }
}, {
  path: "search-complaint",
  component: SearchScreen,
  needsAuthentication: true,
  options: { hideFooter: true, title: "CORE_COMMON_SEARCH_COMPLAINT" }
}, {
  path: "egov-services/booking-resolved/:applicationId?",
  component: ApplicationResolved,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    customFor: "employee",
    title: "MYBK_APPLICATION_DETAILS_RESOLVE",
    titleBackground: true, // Use this if you need white background for title in web version
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/application-details/:applicationId",
  component: ApplicationSummary,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    // title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/park-and-community-center-appDetails-details/:applicationId",
  component: ParkAndCommunityCenterAppDetails,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    customFor: "employee",
    // title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
},

// {
//   path: "egov-services/new-location-details/:applicationId",
//   component: LocationSummary,
//   needsAuthentication: true,
//   options: {
//     hideFooter: true,
//     // title: "BK_CS_HEADER_APPLICATION_SUMMARY",
//     redirectionUrl
//   }
// },

{
  path: "egov-services/cg-application-details/:applicationId",
  component: CGApplicationDetails,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    customFor: "employee",
    // title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/newLocation-application-details/:applicationId",
  component: NewLocationApplicationDetails,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    customFor: "employee",
    // title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/all-MccApplications",
  component: AllMCCApplication,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    customFor: "employee",
    title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/osmcc-application-details/:applicationId",
  component: OSWMCCApplicationDetails,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    customFor: "employee",
    // title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/bwt-application-details/:applicationId",
  component: ApplicationBWTSummary,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    customFor: "employee",
    // title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/home123",
  component: ApplicationSummary,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_CS_HEADER_APPLICATION_SUMMARY",
    redirectionUrl: redirectionUrl
  }
},
//

// {
//   path: "complaint-reassigned/:serviceRequestId?",
//   component: ComplaintAssigned,
//   needsAuthentication: true,
//   options: {
//     hideFooter: true,
//     title: "ES_COMPLAINT_REASSIGNED_HEADER",
//     hideTitle: true,
//     redirectionUrl
//   }
// },
{
  path: "egov-services/DataSubmitted",
  component: ResolveSuccess,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    title: "",
    hideTitle: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/publish-success",
  component: PublishSuccess,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    title: "",
    hideTitle: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/newLocation-approved",
  component: NewLocationApproved,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    title: "",
    hideTitle: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/DriverAssigned",
  component: AssignToDriverSuccess,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    title: "",
    hideTitle: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/reject-bwt-application-success",
  component: RejectBWTApplicationSuccess,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    title: "",
    hideTitle: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/delivered-bwt-application-success",
  component: DeliveredApplicationSuccess,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    title: "",
    hideTitle: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "reassign-success",
  component: ReassignSuccess,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    hideTitle: true,
    title: "CS_COMMON_RE-ASSIGN REQUESTED",
    redirectionUrl: redirectionUrl
  }
},
// {
//   path: "complaint-assigned/:serviceRequestId?",
//   component: ComplaintAssigned,
//   needsAuthentication: true,
//   options: {
//     hideBackButton: true,
//     hideFooter: true,
//     hideTitle: true,
//     title: "ES_COMPLAINT_ASSIGNED_HEADER",
//     redirectionUrl
//   }
// },
{
  path: "egov-services/application-rejected",
  component: ApplicationRejected,
  needsAuthentication: true,
  options: {
    title: "ES_COMPLAINT_REJECTED_HEADER",
    hideTitle: true,
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl,
    hideBackButton: true
  }
}, {
  path: "egov-services/application-submited",
  component: ApplicationSubmited,
  needsAuthentication: true,
  options: {
    title: "ES_COMPLAINT_REJECTED_HEADER",
    hideTitle: true,
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl,
    hideBackButton: true
  }
}, {
  path: "egov-services/application-sendback",
  component: ApplicationBack,
  needsAuthentication: true,
  options: {
    title: "ES_COMPLAINT_BACK_HEADER",
    hideTitle: true,
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl,
    hideBackButton: true
  }
}, {
  path: "egov-services/application-forword",
  component: ApplicationForword,
  needsAuthentication: true,
  options: {
    title: "ES_COMPLAINT_FORWORD_HEADER",
    hideTitle: true,
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl,
    hideBackButton: true
  }
}, {
  path: "egov-services/application-feedback",
  component: ApplicationFeedback,
  needsAuthentication: true,
  options: {
    title: "ES_COMPLAINT_REJECTED_HEADER",
    hideTitle: true,
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl,
    hideBackButton: true
  }
}, {
  path: "egov-services/NewLocationApplication-rejected",
  component: NewLocationApplication,
  needsAuthentication: true,
  options: {
    title: "ES_COMPLAINT_REJECTED_HEADER",
    hideTitle: true,
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl,
    hideBackButton: true
  }
}, {
  path: "assign-complaint/:serviceRequestId?",
  component: AssignComplaint,
  needsAuthentication: true,
  options: {
    title: "ES_ASSIGN_TO_EMPLOYEE_HEADER",
    hideFooter: true,
    redirectionUrl: redirectionUrl
  }
}, {
  path: "reassign-complaint/:serviceRequestId?",
  component: AssignComplaint,
  needsAuthentication: true,
  options: {
    title: "ES_REASSIGN_TO_EMPLOYEE_HEADER",
    hideFooter: true,
    redirectionUrl: redirectionUrl
  }
}, {
  path: "employee-directory",
  component: EmployeeDirectory,
  needsAuthentication: true,
  options: {
    title: "ES_EMPLOYEE_DIRECTORY_HEADER",
    hideFooter: true,
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/reject-booking/:applicationId?",
  component: RejectComplaint,
  needsAuthentication: true,
  options: {
    // title: "ES_REASON_TO_REJECT_HEADER",
    titleBackground: true, // Use this if you need white background for title in web version
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/reject-bwt-booking/:applicationId?",
  component: RejectBWTComplaint,
  needsAuthentication: true,
  options: {
    // title: "ES_REASON_TO_REJECT_HEADER",
    titleBackground: true, // Use this if you need white background for title in web version
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/deliver-application/:applicationId?",
  component: deliverBooking,
  needsAuthentication: true,
  options: {
    // title: "ES_REASON_TO_REJECT_HEADER",
    titleBackground: true, // Use this if you need white background for title in web version
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/not-deliver-application/:applicationId?",
  component: notDeliverBooking,
  needsAuthentication: true,
  options: {
    // title: "ES_REASON_TO_REJECT_HEADER",
    titleBackground: true, // Use this if you need white background for title in web version
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "egov-services/assignto-driver/:applicationId?",
  component: AssignToDriver,
  needsAuthentication: true,
  options: {
    title: "BK_MYBK_ASSIGN_TO_DRIVER_HEADER",
    titleBackground: true, // Use this if you need white background for title in web version
    hideFooter: true,
    customFor: "employee",
    redirectionUrl: redirectionUrl
  }
}, {
  path: "/egov-services/testing",
  component: testing,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_PCC_APPLICATION_REQUEST",
    hideTitle: false,
    customFor: "employee"
  }
}, {
  path: "egov-services/ServicesTest",
  component: ServicesTest,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: " ",
    hideTitle: false,
    // redirectionUrl,
    // hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ALL_APPLICAION_HEADER"
  }
}, {
  path: "egov-services/create-success",
  component: CreateSuccess,
  needsAuthentication: true,
  options: {
    hideBackButton: true,
    hideFooter: true,
    title: "",
    hideTitle: true,
    customFor: "employee"
  }
},

// {
//   path: "/egov-services/MyTry",
//   component: MyTry,
//   needsAuthentication: true,
//   options: {
//     hideFooter: false,
//     hideBackButton: true,
//     title: "BK_MYBK_PCC_APPLICATION_REQUEST",
//     customFor: "employee",
//   }
// },
{
  path: "egov-services/reservedbookingdates",
  component: ReservedDatesList,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_ADMIN_PACC_HOLD_DATES_HEADER",

    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ADMIN_PACC_HOLD_DATES_HEADER"
  }
}, {
  path: "egov-services/reservedates",
  component: ReserveDates,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "BK_MYBK_ADMIN_PACC_HOLD_DATES_HEADER",

    hideTitle: false,
    redirectionUrl: redirectionUrl,
    hideFor: "ao",
    customFor: "employee",
    customTitle: "BK_MYBK_ADMIN_PACC_HOLD_DATES_HEADER"
  }
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-services-emp/Routes/services-routes.js
// module id = 3755
// module chunks = 1143